import { numberComparisonOperators } from "@redotech/redo-flows-core-common/comparison-operators";
import { Schema } from "../type-system/schema";

export const schemaNumberComparisonOperators = [
  ...numberComparisonOperators,
  "greaterThanOrEqual",
  "lessThanOrEqual",
] as const;

export const numberComparisonToLabel: Record<
  NumberComparisonExpression["operator"],
  string
> = {
  ["lessThan"]: "less than",
  ["greaterThan"]: "greater than",
  ["equalTo"]: "equal to",
  ["notEqualTo"]: "not equal to",
  ["greaterThanOrEqual"]: "greater than or equal to",
  ["lessThanOrEqual"]: "less than or equal to",
};

export interface NumberComparisonExpression {
  type: "number_comparison";
  field: keyof Schema["fields"];
  operator: (typeof schemaNumberComparisonOperators)[number];
  comparisonValue: number;
}
